import { DOWNLOAD_QUERY_REPORT_DATA, GET_ANANDA_KEY_CATEGORY_LIST, GET_LAB_TEST_CATEGORY_LIST, GET_LAB_TEST_LIST, GET_QUERY_REPORT_DATA, GET_SAMPLE_DATA_FOR_CATEGORY } from "../../constants";

export function getAnandaKeysCategoryList(data) {
    return {
        type: GET_ANANDA_KEY_CATEGORY_LIST,
        data,
    };
}

export function getQueryReport(data) {
    return {
        type: GET_QUERY_REPORT_DATA,
        data,
    };
}

export function downloadQueryReport(data) {
    return {
        type: DOWNLOAD_QUERY_REPORT_DATA,
        data,
    };
}

export function getSampleDataForCategory(data) {
    return {
        type: GET_SAMPLE_DATA_FOR_CATEGORY,
        data,
    };
}

export function getLabTestList(data) {
    return {
        type: GET_LAB_TEST_LIST,
        data,
    };
}

export function getLabTestCategoryList(data) {
    return {
        type: GET_LAB_TEST_CATEGORY_LIST,
        data,
    };
}